<template>
  <validation-observer id="percentual-perdas-aic" v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row id="data-lancamento-perdas-aic" class="mt-n3 mx-auto">
      <v-col class="pt-0" md="5" cols="12">
        <date-picker
          v-model="dataBase"
          label="Data Base Ponto de Partida"
          type="date"
          :rules="`required|date_precisa_ser_menor_ou_igual_a:${dataProjetada}`"
        />
      </v-col>
      <v-col class="text-center" md="2" cols="12" style="min-width: 60px !important; padding-top: 32px">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
      </v-col>
      <v-col class="pt-0" md="5" cols="12">
        <date-picker
          v-model="dataProjetada"
          label="Data Projetada"
          type="date"
          :rules="`required|date_precisa_ser_maior_ou_igual_a:${dataBase}`"
        />
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12" class="mt-0 pt-0">
        <v-alert dense outlined type="info" class="px-1 py-1">
          IPCA oficial atualizados até:
          <b>{{ dataUltimoIpcaOficial | formatToMonth }}</b>
          ({{ mesesSemAtualizarIpcaOficial }} meses sem atualizar)
          <br />
          <template v-if="dataUltimoIpcaNaoOficial">
            IPCA estimado atualizados até:
            <b>{{ dataUltimoIpcaNaoOficial | formatToMonth }}</b>
          </template>
        </v-alert>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col class="cols-percentage pb-0" cols="6">
        <v-text-field
          label="Taxa Média de Depreciação (%)"
          value="Informar Percentual"
          outlined
          readonly
          hide-details
          class="pointer-events-none"
        />
      </v-col>
      <v-col class="cols-percentage pb-0" cols="6">
        <v-text-field
          v-model="taxaMediaDep"
          :value="taxaMediaDep"
          label="Percentual (%)"
          suffix="%"
          type="number"
          min="0"
          max="100"
        />
      </v-col>
    </v-row>

    <v-row v-for="(percentual, i) in Object.entries(percentuais)" :key="i" class="mx-auto">
      <v-col class="cols-percentage pb-0" cols="6">
        <v-text-field
          :label="percentual[1].label"
          value="Informar Indice"
          outlined
          readonly
          hide-details
          class="pointer-events-none"
        />
      </v-col>
      <v-col class="cols-percentage pb-0" cols="6">
        <validation-provider v-slot="{ errors }" rules="between:0,100">
          <v-text-field
            :value="percentual[1].perc"
            label="Relação VNR/VOC"
            type="number"
            min="0"
            max="1"
            :error-messages="errors"
            @input="setPercentuais(percentual[0], 'perc', $event)"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="6" class="align-center d-flex pb-0">
        <v-checkbox v-model="possuiDevolucoes" label="Possui Valores de Devoluções/Baixas OE" dense hide-details class="mt-n2" />
      </v-col>
      <v-col v-if="possuiDevolucoes" cols="6" class="align-center d-flex pb-0">
        <v-text-field v-model="valores.ValorDevolucao" label="R$" type="number" dense class="mt-2" />
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="6" class="align-center d-flex pb-0 pb-0">
        <v-checkbox v-model="possuiKit" label="Possui Valor do Kit incluso no VOC de OE" dense hide-details class="mt-n2" />
      </v-col>
      <v-col v-if="possuiKit" cols="6" class="pb-0">
        <v-text-field v-model="valores.ValorDemaisItens" label="Demais Itens (R$)" type="number" dense />
        <v-text-field v-model="valores.ValorIncorpRedes" label="Incorporação de Redes - IR (R$)" type="number" dense />
        <v-text-field v-model="valores.ValorPlpt" label="PLPT (R$)" type="number" dense />
      </v-col>
    </v-row>
  </validation-observer>
</template>

<script>
  import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';
  import dayjs from 'dayjs';

  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      DatePicker: () => import('@/components/general/DatePicker.vue')
    },

    emits: ['stepReleased'],

    data: () => ({
      dataUltimoIpcaOficial: '',
      dataUltimoIpcaNaoOficial: ''
    }),

    computed: {
      dataBase: {
        get() {
          return this.$store.state.obrigacoesEspeciais.dataBase;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { dataBase: value });
        }
      },
      dataProjetada: {
        get() {
          return this.$store.state.obrigacoesEspeciais.dataProjetada;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { dataProjetada: value });
        }
      },
      possuiDevolucoes: {
        get() {
          return this.$store.state.obrigacoesEspeciais.possuiDevolucoes;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { possuiDevolucoes: value });
        }
      },
      possuiKit: {
        get() {
          return this.$store.state.obrigacoesEspeciais.possuiKit;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { possuiKit: value });
        }
      },
      taxaMediaDep: {
        get() {
          return this.$store.state.obrigacoesEspeciais.taxaMediaDep;
        },
        set(value) {
          this.$store.dispatch('setObrigacoesEspeciais', { taxaMediaDep: value });
        }
      },
      percentuais: {
        get() {
          return this.$store.state.obrigacoesEspeciais.percentuais;
        }
      },
      valores: {
        get() {
          return this.$store.state.obrigacoesEspeciais.valores;
        }
      },
      mesesSemAtualizarIpcaOficial() {
        var dataAtual = dayjs();
        var qtdMeses = dataAtual.diff(dayjs(this.dataUltimoIpcaOficial), 'month');
        return qtdMeses;
      }
    },

    created() {
      this.getUltimoIndice();
    },

    methods: {
      getUltimoIndice() {
        AtualizacaoIndicesService.getUltimoIndiceIpca('IPCA')
          .then((indice) => {
            this.dataUltimoIpcaOficial = indice.indice_oficial ? indice.indice_oficial.DataRegistro : '';
            this.dataUltimoIpcaNaoOficial = indice.indice_estimado ? indice.indice_estimado.DataRegistro : '';
          })
          .catch(() => this.$toast.error('Erro ao buscar ultimo Índice IPCA.', '', { position: 'topRight' }));
      },

      setPercentuais(key, label, value) {
        this.$store.dispatch('setObrigacoesEspeciais', {
          percentuais: { [key]: { [label]: value } }
        });
      },

      clearInputs(i, key) {
        this.setPercentuais(key, 'perc', '100');
      }
    }
  };
</script>
